<script lang="ts">
	import { Stack } from '@Shelly/shelly-design-system/index';
	import { createEventDispatcher, onDestroy, onMount } from 'svelte';

	let listRef: HTMLElement;
	let scrollParent: HTMLElement;
	let savedOverflow: string;

	const dispatch = createEventDispatcher();

	onMount(() => {
		scrollParent = listRef.closest('.scroll-sidepanel') || listRef.closest('.scroll-drawer');
		if (!scrollParent) return;

		savedOverflow = scrollParent.style.overflow;
		scrollParent.style.overflow = 'hidden';

		const parentRect = scrollParent.getBoundingClientRect();
		const listRect = listRef.getBoundingClientRect();
		listRef.style.maxHeight = `${Math.max(parentRect.bottom - listRect.top, 0)}px`;
	});

	onDestroy(() => {
		if (scrollParent) {
			scrollParent.style.overflow = savedOverflow ?? '';
		}
	});

	const handleScroll = () => {
		if (!listRef) return;

		const { scrollTop, scrollHeight, clientHeight } = listRef;
		const threshold = 10;
		const isAtBottom = scrollTop + clientHeight >= scrollHeight - threshold;

		if (isAtBottom) {
			dispatch('loadMore');
		}
	};
</script>

<div class="recordings-list" bind:this={listRef} on:scroll={handleScroll}>
	<Stack gap="s">
		<slot />
	</Stack>
</div>

<style>
	.recordings-list {
		overflow-y: auto;
	}
</style>
